import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import DateFieldDetail from "./detail";
import DateFieldEdit from "./edit";
import DateFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type Date en: </b>
 * <li>Liste</li>
 * <li>Détails</li>
 * <li>Édition</li>
 */
export function Date() {
    return _jsx(_Fragment, { children: "Date" });
}
var field = fieldsType.date;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, DateFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, DateFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, DateFieldList);
